import { LicenceApplicationStatuses } from "../../../../api/LicenceDetails";
import { ILicenceApplicationTrackerProps } from "./ApplicationTrackers/ILicenceApplicationTrackerProps";

export const GetAppTrackerLabel = ({
  licence,
  licenceProfile,
}: ILicenceApplicationTrackerProps) => {
  let label: string = "";
  switch (licence.lastatus) {
    case LicenceApplicationStatuses.UnderAssessment:
      label = "Under Assessment";
      break;
    case LicenceApplicationStatuses.UnderAssessmentRequestForInformationOutstanding:
      label = "Under Assessment";
      break;
    case LicenceApplicationStatuses.ApplicationCompliance:
      label = "Application Compliance";
      break;
    case LicenceApplicationStatuses.ProposedDeterminationIssued:
      label = "Proposed Determination/Decision Issued";
      break;
    case LicenceApplicationStatuses.ConsiderationofObjections:
      label = "Consideration of Objections (if any)";
      break;
    case LicenceApplicationStatuses.AuthorisationIssued:
      label = "Authorisation Issued";
      break;
    case LicenceApplicationStatuses.AuthorisationReplaced:
      label = "Authorisation Replaced";
      break;
    default:
      label = licence.lastatus;
      break;
  }
  return label;
};
